var map = {
	"./ModulesManagerModule/ModulesManagerModule": [
		"./client/go-modules/modules/ModulesManagerModule/ModulesManagerModule.tsx",
		0
	],
	"./ModulesManagerModule/ModulesManagerModule.tsx": [
		"./client/go-modules/modules/ModulesManagerModule/ModulesManagerModule.tsx",
		0
	],
	"./ModulesManagerModule/ModulesManagerModuleRender": [
		"./client/go-modules/modules/ModulesManagerModule/ModulesManagerModuleRender.tsx",
		1
	],
	"./ModulesManagerModule/ModulesManagerModuleRender.tsx": [
		"./client/go-modules/modules/ModulesManagerModule/ModulesManagerModuleRender.tsx",
		1
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./client/go-modules/modules lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;